/* 会话列表排序 */
import _ from 'lodash'

export default function (conversationList) {
  // console.log("%c Line:7 🍐 会话列表排序方法开始>>>>>", "color:#93c0a4",new Date().getTime());
    const newConversationObj = {}
    const toBeUpdateData = _.values(conversationList)
    const sortedArr = toBeUpdateData.sort(function (a,b) {
        if(b.isTop&&b.isTop==1){
          if(a.isTop&&a.isTop==1){
            return  b.latestSendTime-a.latestSendTime
          }else{
            return 1
          }
        }else if(a.isTop&&a.isTop==1){
          if(b.isTop&&b.isTop==1){
            return  b.latestSendTime-a.latestSendTime
          }else{
            return -1
          }
        }else{
          return b.latestSendTime-a.latestSendTime
        }
    })
    sortedArr.forEach((item) => {
        const key = item.conversationKey
        return (newConversationObj[key] = item)
    })
    
    // console.log("%c Line:24 🌶会话列表排序方法结束>>>>>", "color:red",new Date().getTime());
    return newConversationObj
}
